import api from "../scripts/api";

export class SummarySpreadsheet {
    constructor(options) {
        this._options = options;
        api.summary.get.export(this._options);
    }
}



// WEBPACK FOOTER //
// ./src/spreadsheets/summary-spreadsheet.js